/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1PersonSharedFinancialPaymentMethodDropdown200,
  GetApiV1PersonSharedFinancialPaymentMethodDropdown401,
  GetApiV1PersonSharedFinancialPaymentMethodDropdown500,
  GetApiV1PersonSharedFinancialPaymentMethodDropdownQueryResponse,
} from "../../types/personSharedController/GetApiV1PersonSharedFinancialPaymentMethodDropdown.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1PersonSharedFinancialPaymentMethodDropdown200Schema =
  z.array(
    z.lazy(() => dropDownListViewModelSchema),
  ) as unknown as ToZod<GetApiV1PersonSharedFinancialPaymentMethodDropdown200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1PersonSharedFinancialPaymentMethodDropdown401Schema =
  z.any() as unknown as ToZod<GetApiV1PersonSharedFinancialPaymentMethodDropdown401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1PersonSharedFinancialPaymentMethodDropdown500Schema =
  z.any() as unknown as ToZod<GetApiV1PersonSharedFinancialPaymentMethodDropdown500>;

export const getApiV1PersonSharedFinancialPaymentMethodDropdownQueryResponseSchema =
  z.lazy(
    () => getApiV1PersonSharedFinancialPaymentMethodDropdown200Schema,
  ) as unknown as ToZod<GetApiV1PersonSharedFinancialPaymentMethodDropdownQueryResponse>;
